import { useEffect } from 'react';
import { SVGPureIcon } from '@/ui';
import './index.scss';
import globalStore from '@/store/global';
import InviteCodeModal from '@src/components/modal/invite-code';

function SendButton(props) {
  const { className, disabled, onClick } = props;

  useEffect(() => {
    return () => {
      // 关闭邀请码弹窗
      InviteCodeModal.close?.();
    }
  }, []);

  return (
    <button
      className={[
        'send-btn rounded-full',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        !disabled && globalStore.isDark ? '!bg-[#fff] !hover:bg-[#ffffffE6]':'bg-[#000] hover:bg-[#222]',
        disabled && globalStore.isDark ? '!bg-[#ffffff4D]':'',
        disabled && !globalStore.isDark ? 'send-btn-disable':'',
        className,
      ]}
      disabled={disabled}
      onClick={event => onClick?.(event)}
    >
      <SVGPureIcon name="aircraft" className={`text-[#fff] w-14px h-17px ${globalStore.isDark ? disabled ? '!text-[#0000004D]':'!text-[#000]':''}`} />
    </button>
  );
}

export default SendButton;
